// Module
var code = "<template class=\"mooring-components-tab\">\n  <require from=\"./overview\"></require>\n  <overview production-order-id.bind=\"data.productionOrderId\"></anchor-lines-container>\n</template>\n\n\n";
// Exports
export default code;